/* eslint-disable */
if (process.env.NODE_ENV === 'test') {
  require = require('src/utils/jestWebpackPolyfill').default;
}

const svgRequire = require.context('.', false, /^\.\/.*\.svg$/);
const regName = /^\.\/(.*)\.svg$/;
const imgs = {};

svgRequire.keys().map((path) => {
  const src = svgRequire(path);
  const name = path.replace(regName, '$1');
  imgs[name] = src;
  return imgs;
});

export default imgs;
